import React, { useState } from 'react';
import { MasterDataForm } from './MasterDataForm';
import { MasterDataTable } from './MasterDataTable';
import { Horse, useHorse } from '../../contexts/HorseContext';
import { PlusIcon, XIcon } from 'lucide-react';
import { Impressum } from '../Legal/Impressum';
export const MasterDataPage: React.FC = () => {
  const [editingHorse, setEditingHorse] = useState<Horse | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showImpressum, setShowImpressum] = useState(false);
  const handleEditComplete = () => {
    setEditingHorse(null);
    setIsModalOpen(false);
  };
  const handleEditHorse = (horse: Horse) => {
    setEditingHorse(horse);
    setIsModalOpen(true);
  };
  const handleAddHorse = () => {
    setEditingHorse(null);
    setIsModalOpen(true);
  };
  const toggleImpressum = () => {
    setShowImpressum(!showImpressum);
  };
  if (showImpressum) {
    return <Impressum onBack={toggleImpressum} data-id="element-97" />;
  }
  return <div className="w-full h-full max-w-full" data-id="element-98">
      <div className="flex justify-between items-center mb-4" data-id="element-99">
        <div className="flex items-center" data-id="element-100">
          <h1 className="text-2xl font-bold" data-id="element-101">Pferde Stammdaten</h1>
          <button onClick={toggleImpressum} className="ml-4 text-xs text-gray-600 hover:text-gray-900 hover:underline" data-id="element-102">
            Impressum
          </button>
        </div>
        <button onClick={handleAddHorse} className="px-4 py-2 bg-[#284755] text-white rounded-md hover:bg-[#96c11f] flex items-center" data-id="element-103">
          <PlusIcon size={18} className="mr-2" data-id="element-104" />
          Pferd hinzufügen
        </button>
      </div>
      <div className="bg-white rounded-lg shadow p-3 sm:p-6" data-id="element-105">
        <h2 className="text-xl font-semibold mb-3 sm:mb-4" data-id="element-106">Pferde Übersicht</h2>
        <MasterDataTable onEdit={handleEditHorse} data-id="element-107" />
      </div>
      {/* Modal Popup */}
      {isModalOpen && <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" data-id="element-108">
          <div className="bg-white rounded-lg shadow-lg w-full max-w-2xl max-h-[90vh] overflow-y-auto" data-id="element-109">
            <div className="flex justify-between items-center p-4 border-b" data-id="element-110">
              <h2 className="text-xl font-semibold" data-id="element-111">
                {editingHorse ? 'Pferd bearbeiten' : 'Neues Pferd hinzufügen'}
              </h2>
              <button onClick={() => setIsModalOpen(false)} className="text-gray-500 hover:text-gray-700" data-id="element-112">
                <XIcon size={20} data-id="element-113" />
              </button>
            </div>
            <div className="p-4" data-id="element-114">
              <MasterDataForm horse={editingHorse} onComplete={handleEditComplete} data-id="element-115" />
            </div>
          </div>
        </div>}
    </div>;
};